import {DIASRENDIMENTOS} from "../../Constantes";
import dayjs from 'dayjs';

export const obtenerFechaProximosDeposito = ({bolsillo, numCuotasPagas}) => {

    if (!numCuotasPagas) {
        numCuotasPagas = 0;
    }

    let hoy = dayjs()

    const fechaHoy = dayjs(new Date());
    const fechaInicio = dayjs(bolsillo.fecha);

// Resultado entero (meses completos)
    const mesesCompletos = fechaHoy.diff(fechaInicio, 'month')


    if (bolsillo.dias === DIASRENDIMENTOS[0].nombre) {
        return new Date(hoy.add(mesesCompletos + numCuotasPagas, 'month').set('date', 5).format('YYYY-MM-DD'))
    } else {
        return new Date(hoy.add(mesesCompletos + numCuotasPagas, 'month').set('date', 30).format('YYYY-MM-DD'))
    }


}